"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function pink(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { opacity: 0.5, fillRule: "evenodd", clipRule: "evenodd", d: "M18.357 6.69675L16.9545 8.109C16.4492 7.59794 15.8475 7.19231 15.1842 6.91563C14.5208 6.63896 13.8092 6.49675 13.0905 6.49725C10.1543 6.49725 7.75802 8.82975 7.63202 11.7548H7.62602V17.0963C6.34739 15.7075 5.63931 13.8877 5.64302 12C5.64302 7.85775 8.97752 4.5 13.0905 4.5C14.0701 4.49931 15.04 4.69313 15.9441 5.07023C16.8481 5.44733 17.6683 6.00019 18.357 6.69675ZM18.357 17.3033C16.9956 18.6806 15.1484 19.4693 13.212 19.5V17.502C14.6213 17.4715 15.9634 16.894 16.9545 15.8918L18.357 17.3033Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.52869 18.588V11.7555H9.53394C9.63894 9.80175 11.2454 8.25 13.2119 8.25C15.2459 8.25 16.8952 9.9105 16.8952 11.9595C16.8952 14.0078 15.2459 15.6683 13.2127 15.6683C12.5576 15.6693 11.9143 15.494 11.3504 15.1605V19.2938C10.7146 19.1407 10.1019 18.9036 9.52869 18.5888V18.588ZM13.2119 13.8345C13.4573 13.8337 13.7002 13.7846 13.9266 13.6899C14.153 13.5953 14.3586 13.4569 14.5315 13.2828C14.7044 13.1087 14.8414 12.9022 14.9345 12.6751C15.0276 12.4481 15.0751 12.2049 15.0742 11.9595C15.0742 10.9238 14.2402 10.0845 13.2119 10.0845C12.9666 10.0854 12.7238 10.1346 12.4975 10.2293C12.2712 10.324 12.0657 10.4624 11.8929 10.6365C11.72 10.8106 11.5831 11.017 11.4901 11.244C11.397 11.471 11.3495 11.7142 11.3504 11.9595C11.3504 12.9945 12.1837 13.8345 13.2119 13.8345Z", fill: color }));
}
exports["default"] = pink;
//# sourceMappingURL=pink.js.map